// components/PrivacyContent.jsx
const PrivacyContent = () => (
  <div style={{ maxWidth: '900px', margin: '0 auto', padding: '40px 20px', fontFamily: 'Arial, sans-serif', fontSize: '16px', lineHeight: '1.6', color: '#333' }}>
      <h1 style={{ color: '#103c59' }}>Privacy Policy – Anytime Movers AU</h1>
      <p><strong>Effective Date:</strong> 10th of June 2024</p>

      <p>At Anytime Movers AU, your privacy is important to us. This Privacy Policy outlines how we handle the information you provide and the limits of our responsibility in protecting that data.</p>

      <h2 style={{ color: '#f26c50' }}>1. Information Collection</h2>
      <p>We may collect the following details when you fill out a form or contact us:</p>
      <ul>
        <li>Full name</li>
        <li>Phone number</li>
        <li>Email address</li>
        <li>Pickup and drop-off addresses</li>
        <li>Moving-related notes or comments</li>
      </ul>

      <h2 style={{ color: '#f26c50' }}>2. How Forms Are Processed</h2>
      <p>All data submitted through our website forms is sent directly to our official company email for internal use. This allows us to follow up with you and deliver our services efficiently.</p>

      <p style={{ backgroundColor: '#ffe4e1', padding: '10px', borderLeft: '4px solid #f26c50' }}><strong>⚠️ Important:</strong> Please do not include any sensitive personal or financial information, such as:</p>
      <ul>
        <li>Bank account numbers</li>
        <li>Credit or debit card details</li>
        <li>Tax File Numbers or government IDs</li>
      </ul>
      <p><strong>Anytime Movers AU</strong> does not require or request this type of information and is not liable for any consequences if such data is submitted.</p>

      <h2 style={{ color: '#f26c50' }}>3. Email Retention & Deletion</h2>
      <p>Emails received via form submissions are retained only while:</p>
      <ul>
        <li>They are needed for service-related communication</li>
        <li>The email address remains valid and accessible</li>
      </ul>
      <p>If an email address becomes invalid or the information is no longer required, we securely delete those emails from our system.</p>

      <h2 style={{ color: '#f26c50' }}>4. Use of Information</h2>
      <p>Your information is used strictly for:</p>
      <ul>
        <li>Booking and managing your service</li>
        <li>Internal operational needs</li>
        <li>Legal compliance (if applicable)</li>
      </ul>
      <p>We do not use your data for marketing or share it with any third-party services.</p>

      <h2 style={{ color: '#f26c50' }}>5. No Third-Party Sharing</h2>
      <p>We do not sell, share, or distribute your personal information to any external party except when:</p>
      <ul>
        <li>Required by law (e.g., legal notice, court order)</li>
        <li>Necessary to comply with Australian regulatory obligations</li>
      </ul>

      <h2 style={{ color: '#f26c50' }}>6. Limitation of Liability</h2>
      <p>While we follow best practices to safeguard your data, <strong>Anytime Movers AU</strong> is not liable for any unintended disclosure, access, or misuse of your information once it leaves our secure email system or if submitted outside of advised channels.</p>
      <p>By using our services, you agree that:</p>
      <ul>
        <li>You share your information at your own risk</li>
        <li>Anytime Movers AU is not responsible for the misuse of information outside its control</li>
      </ul>

      <h2 style={{ color: '#f26c50' }}>7. Your Rights</h2>
      <p>You have the right to:</p>
      <ul>
        <li>Request access to the information we hold</li>
        <li>Ask for corrections or updates</li>
        <li>Request removal of your data (where legally permissible)</li>
      </ul>
      <p>To make a request, contact:</p>
      <p>📧 [Insert Email Address]</p>

      <h2 style={{ color: '#f26c50' }}>8. Updates to This Policy</h2>
      <p>We may update this Privacy Policy from time to time. Any changes will be posted on this page with the effective date updated accordingly.</p>

      <h2 style={{ color: '#f26c50' }}>9. Contact Us</h2>
      <p>For privacy-related concerns or questions, contact:</p>
      <p>📧 info@anytimemovers.com.au</p>
</div>
);

export default PrivacyContent;
